import Button from '@ui/button/Button';
import ModalDialog from '@ui/modal/ModalDialog';
import analytics from '@utils/analytics';
import api from '@utils/api';
import React, { useState } from 'react';
import cookie from 'react-cookies';
import { useTranslation } from 'react-i18next';
const CookieCenter = (props) => {
    const { t } = useTranslation();
    const [functionalCookies, setFunctionalCookies] = useState(false);
    const [analyticalCookies, setAnalyticalCookies] = useState(false);
    const [profilingCookies, setProfilingCookies] = useState(false);
    const setDefaultCheckes = () => {
        const acceptedCookies = cookie.load(window.privacyCenterCookieName ? window.privacyCenterCookieName : 'TC_PRIVACY_CENTER');
        if (acceptedCookies) {
            acceptedCookies.split(',').forEach((element) => {
                switch (element) {
                    case '1':
                        setProfilingCookies(true);
                        break;
                    case '2':
                        setAnalyticalCookies(true);
                        break;
                    case '3':
                        setFunctionalCookies(true);
                        break;
                    default:
                        setProfilingCookies(false);
                        setAnalyticalCookies(false);
                        setFunctionalCookies(false);
                }
            });
        }
    };
    const saveCookies = (data) => {
        cookie.save(window.privacyCenterCookieName ? window.privacyCenterCookieName : 'TC_PRIVACY_CENTER', decodeURIComponent(data.tcCookieCenterValue), { path: '/' });
        analytics.cookieConsent(data.eventCategory);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        api.allowPersonalizedTracking(new FormData(e.target)).then((data) => {
            saveCookies(data);
            props.onSubmit();
        });
    };
    const subtitle = () => {
        return (React.createElement("div", { className: "dialog__description" },
            React.createElement("span", { dangerouslySetInnerHTML: { __html: t('legal.cookiecenter.sub', { link: props.cookiepage }) } }),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-6" },
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: t('legal.cookiecenter.info', { link: props.cookiepage }) } })),
                React.createElement("div", { className: "col-md-6" },
                    React.createElement(Button, { type: 'button', cls: ['button--primary'], onClick: () => {
                            api.allowTracking().then((data) => {
                                saveCookies(data);
                                props.onSubmit();
                            });
                        } }, t('legal.cookiecenter.agree'))))));
    };
    const switchOnOff = () => {
        return (React.createElement("div", { className: "yes-or-no" },
            React.createElement("span", { className: "yes" }, t('legal.cookiecenter.on')),
            React.createElement("span", { className: "divisor", "aria-hidden": "true" }, "|"),
            React.createElement("span", { className: "no", "aria-hidden": "true" }, t('legal.cookiecenter.off'))));
    };
    return (React.createElement(ModalDialog, { isOpen: props.showModal, contentLabel: t('legal.cookiecenter.title'), onRequestClose: () => props.onClose(), onAfterOpen: () => setDefaultCheckes(), className: 'cookie-center', overlayClassName: 'cookie-overlay', buttonInHeader: true },
        subtitle(),
        React.createElement("form", { className: "cookie-center__form", onSubmit: handleSubmit },
            React.createElement("div", { className: "cookie-center__columns" },
                React.createElement("div", { className: "cookie-center__column" },
                    React.createElement("div", { className: "cookie-item" },
                        React.createElement("h3", { className: "primary-s" }, t('legal.cookiecenter.technical')),
                        React.createElement("label", { className: "cookie-switch" },
                            React.createElement("span", null, t('legal.cookiecenter.switch')),
                            React.createElement("input", { type: "checkbox", name: "technicalCookies", id: "technicalCookies", checked: true, readOnly: true, tabIndex: -1 })),
                        React.createElement("p", { dangerouslySetInnerHTML: { __html: t('legal.cookiecenter.technicaldesc', { link: props.cookiepage }) } })),
                    React.createElement("div", { className: "cookie-item" },
                        React.createElement("h3", { className: "primary-s" }, t('legal.cookiecenter.functional')),
                        React.createElement("label", { className: "cookie-switch" },
                            React.createElement("input", { type: "checkbox", name: "functionalCookies", id: "functionalCookies", checked: functionalCookies, onChange: (e) => setFunctionalCookies(e.target.checked) }),
                            switchOnOff()),
                        React.createElement("p", { dangerouslySetInnerHTML: { __html: t('legal.cookiecenter.functionaldesc', { link: props.cookiepage }) } }))),
                React.createElement("div", { className: "cookie-center__column" },
                    React.createElement("div", { className: "cookie-item" },
                        React.createElement("h3", { className: "primary-s" }, t('legal.cookiecenter.profiling')),
                        React.createElement("label", { className: "cookie-switch" },
                            React.createElement("input", { type: "checkbox", name: "profilingCookies", id: "profilingCookies", checked: profilingCookies, onChange: (e) => setProfilingCookies(e.target.checked) }),
                            switchOnOff()),
                        React.createElement("p", { dangerouslySetInnerHTML: { __html: t('legal.cookiecenter.profilingdesc', { link: props.cookiepage }) } })),
                    React.createElement("div", { className: "cookie-item" },
                        React.createElement("h3", { className: "primary-s" }, t('legal.cookiecenter.analytical')),
                        React.createElement("label", { className: "cookie-switch" },
                            React.createElement("input", { type: "checkbox", name: "analyticalCookies", id: "analyticalCookies", checked: analyticalCookies, onChange: (e) => setAnalyticalCookies(e.target.checked) }),
                            switchOnOff()),
                        React.createElement("p", { dangerouslySetInnerHTML: { __html: t('legal.cookiecenter.analyticaldesc', { link: props.cookiepage }) } })))),
            React.createElement("div", { className: "cookie-row" },
                React.createElement("p", { dangerouslySetInnerHTML: { __html: t('legal.cookiecenter.contentagree', { link: props.cookiepage }) } })),
            React.createElement("div", { className: "buttons-wrapper" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-6" },
                        React.createElement(Button, { type: "button", onClick: () => api.rejectTracking().then((data) => {
                                saveCookies(data);
                                props.onSubmit();
                            }) }, t('legal.cookiecenter.reject'))),
                    React.createElement("div", { className: "col-md-6" },
                        React.createElement(Button, { type: "submit" }, t('legal.cookiecenter.save'))))))));
};
export default CookieCenter;
